import { SET_SWITCHER } from './actionTypes';

const initialState = {
  isProdSwitcherOpen: localStorage.getItem('isProdMode') === 'true',
};

export default function prodSwitcher(state = initialState, action) {
  switch (action.type) {
    case SET_SWITCHER:
      localStorage.setItem('isProdMode', action.payload.toggle);
      return {
        ...state,
        isProdSwitcherOpen: action.payload.toggle,
      };
    default:
      return state;
  }
}

// export function getIsProdMode(state) {
//   return !!state.prodSwitcher.isProdSwitcherOpen;
// }
